import React from 'react';
import intl from 'react-intl-universal';
import { observable, action, computed, isObservableArray } from 'mobx';
import { baseUrlApis, foxitSignApi } from 'Api/index';
import { store } from './store.index';
import { fileController } from '@/components/viewer/Controllers/index';
import { FOXIT_SIGN_FILE_SIZE_LIMIT } from '@/limit.constant';
import { FoxitSignSubtypeMap, FieldType, TAB_NAME_MAP } from '@components/SignatureListContainer/constants'
import { message } from 'antd';
// import FileSaver from 'file-saver';
import { base64toArrayBuffer, isCNDomain, getLocalStorageUserMapValue, setLocalStorageUserMapValue } from '../utils/utils';

import { MULTI_TABS_TYPES } from 'Components/MultiTabsBar/contant'

const CurrentESignAccountIdMapKey = 'CurrentESignAccountIdMap';

export default class FoxitSignStore {
  @observable foxitSignVisibleModal = null;
  @observable foxitSignRemindDetail = '';
  @observable foxitSignInfo = null;
  @observable discardSignaturesMap = {
    [TAB_NAME_MAP.FillSign]: [],
    [TAB_NAME_MAP.FoxitESign]: []
  };
  @observable currentESignAccountId = '';
  @observable eSignAccountList = [];
  @observable showSwitchAccountsDlg = null;
  @observable isInitESignAccount = false;
  @observable hasESignAccount = false;
  @action initFoxitSignCountInfo() {
    this.currentESignAccountId = '';
    this.eSignAccountList = [];
    this.isInitESignAccount = false;
    this.hasESignAccount = false;
    if (isCNDomain()) {
      return Promise.resolve();
    }
    const errorHandle = err => {
      return Promise.reject(err);
    }
    if(store.userStore.isEnterpriseUser) {
      // 调用 ACRD-6215 接口，获取  eSign Company ID  赋值给 currentESignAccountId
      return foxitSignApi.getEsignEnterpriseUserCompanyDetail().then( companyDetail => {
        if (companyDetail) {
          let {
            companiesObj: companies
          } = companyDetail;
          if (companies.length) {
            this.hasESignAccount = true;
            this.setESignAccountList(companies);
          }
        }
        this.isInitESignAccount = true;
        return Promise.resolve();
      }, errorHandle)
    } else {
      /**
       *  获取 eSIgn multiple account， （通过 Foxit JWT token）  EG-1340
       *  只有一个eSign账户 id 赋值给 currentESignAccountId， eSignAccountList.length是 1
       *  多个则不赋值， eSignAccountList.length 大于 1
      */
      return foxitSignApi.getUserCompanyDetail(store.userStore.userAcount).then( res => {
        if (res) {
          let { companies } = res;
          if (companies && Array.isArray(companies)) {
            return foxitSignApi.getEsignEnterpriseUserCompanyDetail(false).then( companyDetail => {
              if (companyDetail) {
                let {
                  companies: enterpriseUserCompanies
                } = companyDetail;
                   let _companies = [...companies];
                if (enterpriseUserCompanies && enterpriseUserCompanies.length ) {
                  // 过滤个人用户里面被企业管理的eSign账号
                  _companies = companies.filter( item => !enterpriseUserCompanies.includes(item.companyId + ''));
                }
                if (_companies.length) {
                  this.hasESignAccount = true;
                  _companies.forEach(item => item.companyId += '');
                  this.setESignAccountList(_companies);
                }
              }
              this.isInitESignAccount = true;
              return Promise.resolve();
            }, errorHandle)
          }
          this.isInitESignAccount = true;
          return Promise.resolve();
        }
        return errorHandle('GetUserCompany error');
      }, errorHandle)
    }
  }
  @computed get isDisableEsign() {
    let { pdfSignConfig: { isDisableFoxitEsignService }, enterpriseSetting } = store.appStore;
    let isACDisableEsign = enterpriseSetting && isObservableArray(enterpriseSetting.disableFeatures) && enterpriseSetting.disableFeatures.includes('FoxitSign');
    return isDisableFoxitEsignService || isACDisableEsign;
  }
  @action getUserCompanySubscriptionDetails(companyIds = []) {
    let promises = [...companyIds.map( companyId => {
      return foxitSignApi.getUserCompanySubscriptionDetails(companyId).then(
        plan => Promise.resolve(plan || {}), () => Promise.resolve({})
      )
    })];
    return Promise.all(promises);
  }
  @action updateCurrentESignAccountId(eSignAccountId) {
    this.currentESignAccountId = eSignAccountId;
    setLocalStorageUserMapValue(this.getCurrentUserID(), localStorage, CurrentESignAccountIdMapKey, this.currentESignAccountId);
  }
  @action setESignAccountList(companies) {
    this.eSignAccountList = companies;
    let currentESignAccountIdFormStorage = getLocalStorageUserMapValue(this.getCurrentUserID(), localStorage, CurrentESignAccountIdMapKey);
    if (!currentESignAccountIdFormStorage || !companies.find( item => item.companyId === currentESignAccountIdFormStorage)) {
      if (currentESignAccountIdFormStorage) {
        // 说明它不在列表里面, 先移除
        setLocalStorageUserMapValue(this.getCurrentUserID(), localStorage, CurrentESignAccountIdMapKey, currentESignAccountIdFormStorage, true);
      }
      if (this.eSignAccountList.length === 1) {
        this.currentESignAccountId = this.eSignAccountList[0].companyId;
        setLocalStorageUserMapValue(this.getCurrentUserID(), localStorage, CurrentESignAccountIdMapKey, this.currentESignAccountId);
      } 
    } else {
      this.currentESignAccountId = currentESignAccountIdFormStorage;         
    }
  }
  @action setShowSwitchAccountsDlg(method) {
    this.showSwitchAccountsDlg = method
  }
  @action onCancelFoxitSign() {
    this.foxitSignVisibleModal = null;
    // store.userStore.updateFoxitSignEnvelopeInfo(null);
    // store.taskStore.doCleanTaskFileList();
  }
  @action updateFoxitSignVisibleModal({ modal, detail }) {
    this.foxitSignVisibleModal = modal;
    this.foxitSignRemindDetail = detail;
  }
  @action updateFoxitSignInfo(value) {
    this.foxitSignInfo = value;
  }
  @action foxitSignAuthStatus(jwt, companyId) {
    return baseUrlApis.foxitSignAuthStatus(jwt, companyId);
  }
  @action async doRequestFoxitSign() {
    this.checkDocAndFoxitSignStatus('signature', async () => {
      const docInfo = await fileController.getDocInfo();
      const docBase64 = await fileController.getCurrentDocStream(1);
      const divideIndex = docBase64.data.indexOf(',') + 1;
      const res = await foxitSignApi.createEnvelopViaBase64([docInfo.fileName], [docBase64.data.substr(divideIndex)]);
      if (res.ret === 0 && res.data && res.data.forwardResult) {
        const { forwardResult } = res.data;
        const {
          embeddedSendingSession: { embeddedSessionURL },
        } = forwardResult;

        if (embeddedSessionURL) {
          let useUrl = embeddedSessionURL.replace('http://', 'https://');
          const { full } = store.appStore.lng;
          useUrl +=  `${useUrl.indexOf('?') > -1  ? '&' : '?'}lang=${full}`;
          this.showIframeTab(useUrl, {
            titleKey: 'toolbar.fillAndSign.RequestSignature.title',
            key: `${MULTI_TABS_TYPES.REQUEST_SIGNATURE}_${new Date().getTime()}`,
            className: `${MULTI_TABS_TYPES.REQUEST_SIGNATURE}_iframe`,
            type: MULTI_TABS_TYPES.REQUEST_SIGNATURE
          });
        }
      } else {
        store.appStore.showLoading(false);
        store.appStore.setGlobalMessage({
          type: 'error',
          content: intl.get('FoxitSign.RequestSignature.Error.serverError'),
        });
        console.error('foxit sign error');
      }
    })
  }
  @action getFoxitSignProductType() {
    return new Promise( (resolve) => {
      let result = 'IT';
      this.getFoxitSignStatus().then(
        (res) => {
          if (res && (res.ret === 0 || (res.ret >=50000 && res.ret <= 59999))) {
            const { data } = res;
            this.updateFoxitSignInfo(data);
            const {
              subscribe_type, subscribe_status
            } = data;
            // subscribe_status 0=Not subscribed 1=Subscription valid 2=Subscription expired 3=Trail 4=Trail expired
            // subscribe_type 1=SMB 2=Enterprise 3=Individual
            // envelop_status 0=Unavailable 1=Available
            let subscribeTypeStr = '';
            let subscribeStatusStr = '';

            switch (subscribe_type) {
              case 1:
                subscribeTypeStr = 'S';
                break;
              case 2:
                subscribeTypeStr = 'E';
                break;
              case 3:
                subscribeTypeStr = 'I';
                break;
              default:
                break;
            }
            switch (subscribe_status) {
              case 0:
                break;
              case 1:
              case 2:
                subscribeStatusStr = 'S';
                break;
              case 3:
              case 4:
                subscribeStatusStr = 'T';
                break;
              default:
                break;
            }
            result = subscribeTypeStr && subscribeStatusStr ? (subscribeTypeStr + subscribeStatusStr) : 'IT';
          }
          if (result.ret === 110016) {
            this.updateFoxitSignVisibleModal({ modal: 'Intro' });
          }
        },
        () => {}
      ).finally( () => {
        resolve(result);
      });
    })
  }
  @action getFoxitSignStatus() {
    return new Promise( (resolve, reject) => {
      return store.userStore
        .getUserJWT('FoxitSign')
        .then(
          (result) => {
            if (result.ret === 0) {
              const { jwt } = result.data;
              store.userStore.updateJWT(jwt);
              // 增加 currentESignAccountId 参数
              return this.foxitSignAuthStatus(jwt, this.currentESignAccountId);
            }
          },
          reject
        )
        .then(
          (result) => {
            resolve(result);
          },
          reject
        );
    })
  }
  @action requestFoxitSignStatus(success) {
    return this.getFoxitSignStatus().then( (result) => {
        if (result && (result.ret === 0 || (result.ret >=50000 && result.ret <= 59999))) {
          // envelop_status: 0
          // subscribe_status: 0
          // subscribe_type: 1=SMB 2=Enterprise 3=Individual
          const { data } = result;

          this.updateFoxitSignInfo(data);
          success && success();
        }
        if (result.ret === 110016) {
          this.updateFoxitSignVisibleModal({ modal: 'Intro' });
        }
      },
      () => {}
    );
  }
  @action async doShowDocumentStatus() {
    this.checkDocAndFoxitSignStatus('subscribeStatus', async () => {
      let documentsListUrl = await foxitSignApi.createEmbeddedUrl();
      if (documentsListUrl) {
        this.showIframeTab(documentsListUrl, {
          titleKey: 'toolbar.fillAndSign.DocumentStatus.iframeTitle',
          key: `${MULTI_TABS_TYPES.DOCUMENT_STATUS}_${new Date().getTime()}`,
          className: `${MULTI_TABS_TYPES.DOCUMENT_STATUS}_iframe`,
          type: MULTI_TABS_TYPES.DOCUMENT_STATUS
        });
      } else {
        console.error('foxit sign error');
        store.appStore.setGlobalMessage({
          type: 'error',
          content: intl.get('FoxitSign.RequestSignature.Error.serverError'),
        });
        store.appStore.showLoading(false);
      }
    })
  }
  @action async doApplyAllSignature(fn = () => {},isFromApplyAll) {
    this.checkDocAndFoxitSignStatus('subscribeStatus', () => { 
      store.appStore.showLoading(false);
      fn()
    }, isFromApplyAll)
  }
  checkDocAndFoxitSignStatus = async (type, callback, isFromApplyAll = false) => {
    if (!window.__online__) {
      store.appStore.doNotifyErrors('offline');
      return;
    }

    try {
      const docInfo = await fileController.getDocInfo();

      // 超过20M停止操作
      if (docInfo.size > 1024 * 1024 * FOXIT_SIGN_FILE_SIZE_LIMIT) {
        store.appStore.setGlobalMessage({
          type: 'error',
          content: intl.get('FoxitSign.RequestSignature.Error.fileOverSize', { fileSize: FOXIT_SIGN_FILE_SIZE_LIMIT }),
        });

        return;
      }
      this.checkFoxitSignStatus(type, callback, isFromApplyAll)
    } catch (error) {
      console.error(error);
      store.appStore.showLoading(false);
    }
  }
  @action checkFoxitSignStatus = async (type, callback, isFromApplyAll = false) => {
    const checkFoxitSignStatusFn = async () => {
      try {
        if (type === 'signature') {
          store.appStore.showLoadingWithMsg({show:true,msg:"UploadingFile"});
        } else if (type === 'subscribeStatus') {
          store.appStore.showLoading(true);
        }
        await this.requestFoxitSignStatus();
        this.onShowFoxitSignByStatus(type, isFromApplyAll);
  
        callback && callback();
      } catch (error) {
        console.error(error);
        store.appStore.showLoading(false);
      }
    }

    try {
      if (!this.hasESignAccount || !this.isInitESignAccount) {
        await this.initFoxitSignCountInfo();
      }
  
      if (this.hasESignAccount && !this.currentESignAccountId && this.eSignAccountList.length > 1) {
        this.showSwitchAccountsDlg(checkFoxitSignStatusFn)
      } else {
        checkFoxitSignStatusFn();
      }
    } catch (error) {
    }
  }
  showIframeTab = (url, { titleKey, key, className, type }) => {
    const iframeOnload = () => {
      store.appStore.showLoading(false);
    };
    const iframeOnerror = () => {
      store.appStore.showLoading(false);
    };
    let iframeTab = {
      title: intl.get(titleKey),
      key,
      type,
      content: (
        <React.Fragment>
          <iframe
            className={className}
            onLoad={iframeOnload}
            onError={iframeOnerror}
            src={url}
            width="100%"
            height="100%"></iframe>
        </React.Fragment>
      )
    }
    if (!store.viewer.multiTabsTabPane.length) {
      store.viewer.initMultiTabsTabPane();
    }
    store.viewer.updateMultiTabsTabPane([iframeTab])
    store.viewer.updateMultiTabsActiveKey(key, type);
  }
  onShowFoxitSignByStatus = (type, isFromApplyAll = false) => {
    if (!this.foxitSignInfo) {
      throw 'Get FoxitSignStatus Error';
    }
    let {
      foxitSignInfo: { subscribe_status, envelop_status },
    } = this;

    // subscribe_status = 1
    // envelop_status= 1
    // subscribe_status 0：没有订阅或试用
    if (subscribe_status === 0) {
      this.updateFoxitSignVisibleModal({ modal: 'Intro' });
      throw 'subscribe_status: 0'
    }

    if (type === 'subscribeStatus' && !isFromApplyAll) {
      // document status(包括首页的esignAgrements)、upload signature、create signature（online下载方式的时候）: 只检查是否订阅 (ApplyAll 除外)
      // 如果 订阅过了，继续上面动作之后的步骤
      return Promise.resolve();
    }

    // subscribe_status 1 或 3： 表示可以正常使用Foxit Sign功能
    if (subscribe_status === 1 || subscribe_status === 3) {
      if (envelop_status === 0) {
        const { roleInfo } = store.userStore;

        if (roleInfo) {
          this.updateFoxitSignVisibleModal({ modal: 'Remind', detail: 'FoxitSign.RequestSignature.Remind.noEnvelopeEnterprise' });
        } else {
          this.updateFoxitSignVisibleModal({ modal: 'Remind', detail: 'FoxitSign.RequestSignature.Remind.noEnvelope' });
        }

        throw 'no Envelope';
      } else {
        if (type === 'signature') {
          if (!store.viewer.hasOpenFile) {
            throw 'no opened file';
          }
        }
      }
    }

    // subscribe_status 2：Subscription expired account
    if (subscribe_status === 2) {
      const { roleInfo } = store.userStore;

      if (roleInfo) {
        this.updateFoxitSignVisibleModal({ modal: 'Remind', detail: 'FoxitSign.RequestSignature.Remind.subscribeExpiredEnterprise' });
      } else {
        this.updateFoxitSignVisibleModal({ modal: 'Remind', detail: 'FoxitSign.RequestSignature.Remind.subscribeExpired' });
      }

      throw 'subscribe expired';
    }

    // subscribe_status 4：Trial expired account, 企业用户没有试用
    if (subscribe_status === 4) {
      this.updateFoxitSignVisibleModal({ modal: 'Remind', detail: 'FoxitSign.RequestSignature.Remind.trialExpired' });
      throw 'trail expired';
    }
  }
  updateDiscardSignaturesMap = (tabName, discardSignatures = []) => {
    this.discardSignaturesMap[tabName] = [...discardSignatures];
  }

  // ==============================
  // 应用所有签名
  @action async doApplyAllSignatureWithDigitalSign (showSaveAs=true, callback) {
    this.checkDocAndFoxitSignStatus('subscribeStatus', () => { 
      store.appStore.showLoading(false);
      this._doApplyAllSignatureWithDigitalSign(showSaveAs, callback);
    }, true);
    return ;
  }
  async _doApplyAllSignatureWithDigitalSign (showSaveAs=true, callback) {
    let foxitESignModalMaskDom = document.getElementById('foxitESignModalMask');
    const pdfViewer = pdfui.pdfViewer;
    const signatures = pdfViewer.getOnlineSignManger().onlineSignList;
    const errorHandle = error => {
      message.destroy();
      let _error = (error && typeof error === 'string') ? error : "Exception in signing, Please try again later.";
      message.error(_error, 5);
      foxitESignModalMaskDom.style.display = 'none';
      throw error;
    }

    message.loading('Signing...', 0);
    foxitESignModalMaskDom.style.display = 'block';
    // 1. 获取signature平台token
    await foxitSignApi.createESignAccessToken().catch(errorHandle);
    // 2. 创建信封
    const { documentIds, envelopeId, saveDocumentOnline } = await foxitSignApi.createEnvelope().catch(errorHandle);
    // 3. 更新信封历史
    await foxitSignApi.updateEnvelopeHistory(envelopeId, 'EnvelopeViewedInSession');
    // 4. 更新签名图片、rect、documentId
    let deviceRectMap = {};
    for (const signature of signatures) {
      let { fieldType, dataURL } = signature
      signature.FoxitSignSubtype = FoxitSignSubtypeMap[fieldType];
      try {
        let newBase64 = await foxitSignApi.getPartySignImage(dataURL.split(',')[1], fieldType)
        if (newBase64) {
          signature.buffer = base64toArrayBuffer('data:image/png;base64,' + newBase64);
        }
        let _rect = await this.getSignaturePDFRect(signature, deviceRectMap);
        if (_rect) {
          signature.rect = _rect;
        }
      } catch (error) {
        errorHandle(error)
      }
    }
    deviceRectMap = null;
    // 5. 签名并转换签名摘要
    const pdfDoc = pdfViewer.getCurrentPDFDoc();
    const userInfo = store.userStore.userInfo;
    const signInfo = {
      email: userInfo.userEmail, 
      phone: userInfo.userMobile || userInfo.phone, 
      distinguishName: '', 
      location: '', 
      text: '',
      // FoxitEsign签名 下面信息(reason、filter、subfilter)暂时写死
      reason: 'Electronic Signature completed successfully via Foxit eSign', // FoxitEsign签名暂时写死
      filter: 'Adobe.PPKLite',
      subfilter: 'adbe.pkcs7.detached',
      documentID: documentIds[0],
      // FoxitEsign签名 字典相关信息
      FoxitSignEndpoint: foxitSignApi.getFoxitSignHost(),
      FoxitSignVersion: 1,
      FoxitSignFT: 'FoxitSignContent',
      FoxitSignTxnID: JSON.stringify({
        documentID: documentIds[0],
        envelopeID: envelopeId,
        IfUploadDoc: saveDocumentOnline,
      }),
      showLogo: false
    };
    await pdfDoc.signForESignUS(signInfo, signatures, (signHashData) => {
      return foxitSignApi.getPKCS7(signHashData);
    }).then(([file, fileBase64]) => {
      // 6. 更新信封历史
      foxitSignApi.updateEnvelopeHistory(envelopeId, 'EnvelopeSigned');
      message.destroy();
      message.success("Signed successfully!", 2.5);
      foxitESignModalMaskDom.style.display = 'none';
      let fileName = store.docStore.docInfo.fileName;
      fileName = fileName.substr(0, fileName.lastIndexOf('.')) + '_Signed.pdf';
      pdfDoc.docModified = false;
      pdfDoc.otherOptions.afterHiddenDataOperateAndReopenFile = true;
      // 替换当前文档
      let { serviceModeOfClientInfo } = store.appStore;
      const openFilePromise = pdfui.openPDFByFile(file, { fileName }).then(() => {
        if (serviceModeOfClientInfo) {
          // 如果是 小程序打开的本地文档，要把这些信息设置回去
          store.appStore.setServiceModeOfClientInfo(serviceModeOfClientInfo);
          // 文件重新打开后 docModified 会被重置为false 需要设置回去，让文档保存回原文件 
          store.appStore.doUpdateDocModified(true);
        }
        callback && callback(true);
      });
      if (saveDocumentOnline) {
        // 7. upload doc buffer
        openFilePromise.then(() => {
          const _signatures = signatures.filter(item => item.fieldType === FieldType.Signature);
          let signatureSource = _signatures.length ? _signatures[0].dataURL.split(',')[1] : '';
          foxitSignApi.uploadExecutedDocument(envelopeId, documentIds, fileBase64, signatureSource);
        });
      } else {
        // 7. 更新信封历史 EnvelopeExecuted
        openFilePromise.then(() => {
          foxitSignApi.updateEnvelopeHistory(envelopeId, 'EnvelopeExecuted');
        });
      }
      // FileSaver.saveAs(file, fileName);
      showSaveAs && pdfui.eventEmitter.emit('apply-esign-to-save');    
      return true;
    }).catch(errorHandle);
  }
  // 未订阅电子签章功能弹窗提示框
  @action alertSales () {
    const contactSales = pdfui.i18n.t('e-sign-china:buttons.contactSales');
    pdfui.alert('e-sign-china:stampList.inEnterpriseNotCreated', undefined, undefined, 'warning', undefined, undefined, undefined, contactSales).then((res) => {
      // 说明是确定按钮
      if (res !== 'cancel') {
        window.open('https://www.foxitsoftware.cn/esign#sales');
      }
    });
  }
  getSignaturePDFRect(signature, deviceRectMap = {}) {
    let { pdfViewer } =store.viewer;
    let { id, pageIndex } = signature; 
    const pageRender = pdfViewer.getPDFPageRender(pageIndex);
    return pageRender.getSignaturePDFRect(id, deviceRectMap);
  }
  getCurrentUserID() {
    let { userInfo: { cUserID },  roleInfo, isEnterpriseUser } = store.userStore;
    let valueKey = cUserID;
    if (isEnterpriseUser) {
      valueKey += `_${roleInfo.enterpriseId}`;
    }
    return valueKey;
  }
}
